import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import ShopLocalVoucher from "./ShopLocalVoucher";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft } from "react-icons/md";

const ShopLocalVoucherPage = () => {
  // state to make the tab active
  const [currentTab, setcurrentTab] = useState("");
  // state to toggle the loader page
  const [loading, setLoading] = useState(true);

  const path = window.location.href;
  const endPath = path.split("/")[4];

  // hooks to use the end path to set the current tab
  useEffect(() => {
    if (endPath === "voucher") {
      setcurrentTab("voucher");
    }
    setTimeout(() => {
      setLoading(false)
    }, 300);
  }, []);

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4 shopLocalAi">
          <p className="page-text dashboard">
            <Link to={"/shop-local-AI/business-profile"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">CommunityX AI</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink
                to={"/shop-local-AI/business-profile"}
                className={"tabs_li"}
              >
                Business Profile
              </NavLink>
              <NavLink
                to={""}
                className={currentTab === "voucher" ? " activeTab" : "tabs_li"}
              >
                Voucher
              </NavLink>
              <NavLink to={"/shop-local-AI/coupon"} className={"tabs_li"}>
                Coupon
              </NavLink>
            </div>

            <div className="mt-3">
              <ShopLocalVoucher />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopLocalVoucherPage;
